import React, { useState } from "react";
import FormField from "../FormField";
import "../../pages/admins/admins.css";
import { toast } from "react-toastify";
import { Modal } from "bootstrap";

const AddAdminForm = () => {
  const [role, setRole] = useState("");

  const handleRole = (event) => {
    setRole(event.target.value);
  };

  const handleAddAdmin = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    var object = {};
    formData.forEach(function (value, key) {
      object[key] = value;
    });
    object.role = role;
    const response = null;
    if (response) {
      toast.success("Admin add successfully");
      // const modalElement = document.getElementById("addAdminsModal");
      // const modal = Modal.getInstance(modalElement);
      // modal.hide();
      window.location.reload();
    }
  };

  return (
    <div
      className="modal fade"
      id="addAdminsModal"
      aria-hidden="true"
      aria-labelledby="exampleModalToggleLabel"
      tabindex="-1"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalToggleLabel">
              Add Admin
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleAddAdmin}>
              <FormField
                label="Name"
                type="text"
                placeholder="Name"
                name="name"
              />
              <FormField
                label="Email"
                type="text"
                placeholder="Email"
                name="email"
              />
              <FormField
                label="Phone Number"
                type="text"
                placeholder="Phone number"
                name="phoneNumber"
              />
              <FormField
                label="Password"
                type="password"
                placeholder="Password"
                name="password"
              />

              <div className="mb-3">
                <label for="recipient-name" className="col-form-label">
                  Role
                </label>
                <div className="role">
                  <select
                    className="form-select "
                    aria-label="Default select example"
                    onChange={handleRole}
                  >
                    <option value="Admin">Admin</option>
                    <option value="Super Admin">Super Admin</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  id="add-admin-button"
                  className="btn-model"
                  //   data-bs-target="#exampleModalToggle2"
                  //   data-bs-toggle="modal"
                  type="submit"
                >
                  Add Admin
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAdminForm;
